import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 p-4">
      <div className="max-w-4xl mx-auto">
        <Button 
          variant="ghost" 
          className="text-white mb-4"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Voltar
        </Button>
        
        <Card className="bg-white/10 border-white/20 text-white">
          <CardHeader>
            <CardTitle className="text-2xl">Política de Privacidade - GGEE</CardTitle>
            <p className="text-blue-300 text-sm">Última atualização: Abril de 2026</p>
          </CardHeader>
          <CardContent className="space-y-6 text-gray-200">
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-2">1. Introdução</h2>
              <p>
                O GGEE (Gerenciador de Gestão de Escola Esportiva) está comprometido em proteger a privacidade 
                dos nossos usuários. Esta política descreve como coletamos, usamos e protegemos suas informações.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">2. Informações Coletadas</h2>
              <p>Coletamos as seguintes informações:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li><strong>Dados de cadastro:</strong> Nome, email, telefone, senha (criptografada)</li>
                <li><strong>Dados dos alunos:</strong> Nome, data de nascimento, turma, dados de presença</li>
                <li><strong>Dados de uso:</strong> Registros de acesso, presenças, votações na Arena</li>
                <li><strong>Dados de pagamento:</strong> Informações de mensalidades (não armazenamos dados de cartão)</li>
                <li><strong>Notificações:</strong> Token do dispositivo para envio de notificações push</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">3. Uso das Informações</h2>
              <p>Utilizamos suas informações para:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Fornecer e manter nossos serviços</li>
                <li>Gerenciar alunos, turmas e presenças</li>
                <li>Enviar notificações sobre avisos da escola</li>
                <li>Processar e controlar mensalidades</li>
                <li>Melhorar nossos serviços</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">4. Compartilhamento de Dados</h2>
              <p>
                Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, 
                exceto quando necessário para:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Cumprir obrigações legais</li>
                <li>Proteger nossos direitos</li>
                <li>Fornecer serviços essenciais (ex: Firebase para notificações)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">5. Segurança</h2>
              <p>
                Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Criptografia de senhas (bcrypt)</li>
                <li>Conexões seguras (HTTPS/SSL)</li>
                <li>Autenticação via tokens JWT</li>
                <li>Acesso restrito aos dados</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">6. Seus Direitos</h2>
              <p>Você tem direito a:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Acessar seus dados pessoais</li>
                <li>Corrigir dados incorretos</li>
                <li>Solicitar exclusão dos seus dados</li>
                <li>Revogar consentimento para notificações</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">7. Cookies e Armazenamento Local</h2>
              <p>
                Utilizamos localStorage para manter sua sessão ativa. Não utilizamos cookies de rastreamento 
                de terceiros.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">8. Menores de Idade</h2>
              <p>
                Nosso serviço é destinado a escolas esportivas. Dados de alunos menores de idade são 
                gerenciados pelos responsáveis e administradores da escola.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">9. Alterações nesta Política</h2>
              <p>
                Podemos atualizar esta política periodicamente. Notificaremos sobre mudanças significativas 
                através do aplicativo.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-2">10. Contato</h2>
              <p>
                Para dúvidas sobre esta política ou seus dados, entre em contato conosco através do 
                suporte no aplicativo.
              </p>
            </section>

            <div className="border-t border-white/20 pt-4 mt-6">
              <p className="text-sm text-gray-400">
                © 2026 GGEE - Gerenciador de Gestão de Escola Esportiva. Todos os direitos reservados.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
